<template>
<div class="fc-page mg-page mg-purchase_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>采购订单</h1><p>记录物资采购，核对供应商、数量与费用</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">新增采购订单</v-btn></div></header><section class="fc-filters" aria-label="采购订单筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="getTableDataList"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-select :items="selectGoodsList" v-model="query.goodsId"
							item-text="goodsName" item-value="id" label="商品" dense outlined color="#d9363e" aria-label="商品"></v-select></div>
<div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							    transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div>
<div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								 transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="采购记录"><div class="fc-list-heading"><h3>采购记录</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
				</v-chip>
			</template>


		<template v-slot:item.price="{item}"><span class="fc-number">{{item.price}}</span></template><template v-slot:item.quantity="{item}"><span class="fc-number">{{item.quantity}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="新增采购订单" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-package-variant-closed</v-icon></span><div class="mg-dialog-title"><h2><span>新增采购订单</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭新增采购订单" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-select :items="selectGoodsList" v-model="add.order.goodsId"
						item-text="goodsName" item-value="id" label="商品名称" dense outlined color="#d9363e" aria-label="商品名称"></v-select>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="供应商名称" v-model="add.order.supplierName" dense outlined color="#d9363e" aria-label="供应商名称"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="采购价格"  type="number" v-model="add.order.price" dense outlined color="#d9363e" aria-label="采购价格"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="数量" type="number" v-model="add.order.quantity" dense outlined color="#d9363e" aria-label="数量"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field label="交接人" v-model="add.order.bizUserName" dense outlined color="#d9363e" aria-label="交接人"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="订单备注" v-model="add.order.memo" dense outlined color="#d9363e" aria-label="订单备注"></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<span>订单总金额：</span>
						<span v-if="add.order.price && add.order.quantity" color="red">
							{{(add.order.quantity * add.order.price).toFixed(2)}} 元
						</span>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitAddOder" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "purchase-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '采购管理',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '商品',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '供应商',
							value: 'supplierName',
							sortable: false
						},
						{
							text: '价格',
							value: 'price',
							sortable: false
						},
						{
							text: '数量',
							value: 'quantity',
							sortable: false
						},
						{
							text: '总价',
							value: 'totalFee',
							sortable: false
						},
						{
							text: '状态',
							align: 'center',
							value: 'status',
							sortable: false
						},
						{
							text: '制单人',
							value: 'creatorName',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				selectShopList:[], //选择门店数据源
				selectGoodsList:[], //选择商品数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
		
				},
				add:{
					dialog: false,
					order:{
						shopId:"",
						goodsId:"",
						quantity:"",
						price:"",
						totalFee:"",
						supplierName:"",
						bizUserName:"",
						memo:""
					}
				}
			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getGoodsListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog(){
				this.add.dialog = true;
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/purchase/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				}
				else if (state === "0") {
					stName = "已取消";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddOder(){
				//提交订单
				// api
				
				if(!this.add.order.price){
					this.$noty.error("请输入价格");
					return
				}
				
				if (!utils.isDecimal(this.add.order.price)){
					this.$noty.error("价格只能为正数且最多2位小数");
					return
				}
				
				const that = this;
				let url = `/erp/purchase/create`;
				let postData = {...this.add.order};
				postData.shopId = this.shopId;
							
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			
			getGoodsListForSelect(){
				const that = this;
				let url = `/erp/merchant/goods/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGoodsList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>
<style>
</style>
<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
